"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSomeAdAnalyticsVideoIndexKeyword = void 0;
const immutable_1 = require("immutable");
const AdAnalyticsVideo_1 = require("../entity/AdAnalyticsVideo");
const adAnalyticsVideoIndexKeywordSection_1 = require("./adAnalyticsVideoIndexKeywordSection");
const timeObject_1 = require("./timeObject");
const createSomeAdAnalyticsVideoIndexKeyword = ({ text = 'キーワード', sections = immutable_1.List([
    adAnalyticsVideoIndexKeywordSection_1.createSomeAdAnalyticsVideoIndexKeywordSection({
        start: timeObject_1.createSomeTimeObject({ hours: 0, minutes: 0, seconds: 10 }),
        end: timeObject_1.createSomeTimeObject({ hours: 0, minutes: 0, seconds: 20 }),
    }),
    adAnalyticsVideoIndexKeywordSection_1.createSomeAdAnalyticsVideoIndexKeywordSection({
        start: timeObject_1.createSomeTimeObject({ hours: 0, minutes: 0, seconds: 15 }),
        end: timeObject_1.createSomeTimeObject({ hours: 0, minutes: 0, seconds: 30 }),
    }),
]), } = {}) => new AdAnalyticsVideo_1.AdAnalyticsVideoIndexKeyword({
    text,
    sections,
});
exports.createSomeAdAnalyticsVideoIndexKeyword = createSomeAdAnalyticsVideoIndexKeyword;
